module.exports = __webpack_public_path__ + "img/listas_qr.316d9a5e.png";